import { render, staticRenderFns } from "./remoteSql.vue?vue&type=template&id=9ff73c7e&scoped=true"
import script from "./remoteSql.vue?vue&type=script&lang=js"
export * from "./remoteSql.vue?vue&type=script&lang=js"
import style0 from "./remoteSql.vue?vue&type=style&index=0&id=9ff73c7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff73c7e",
  null
  
)

export default component.exports